/**
 * @param {number} value
 * @returns {string}
 */
export const styleSpacingValue = (value) => (Number.isNaN(+value) ? value : `${parseInt(value, 10) * 8}px`)
